(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-landing-v6"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCard(card) {
      const imgs = card.querySelectorAll('.b2bv6-pcard__img');
      const dots = card.querySelectorAll('.b2bv6-pcard__dot');
      const prev = card.querySelector('[data-pcard-prev]');
      const next = card.querySelector('[data-pcard-next]');
      if (imgs.length < 2) return;
      let active = 0;
      function show(i) {
        const n = imgs.length;
        const target = ((i % n) + n) % n;
        imgs[active].classList.remove('is-active');
        if (dots[active]) dots[active].classList.remove('is-active');
        active = target;
        imgs[active].classList.add('is-active');
        if (dots[active]) dots[active].classList.add('is-active');
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(active - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(active + 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(i); });
      });
    }
    function initAll() {
      document.querySelectorAll('[data-pcard]').forEach(function (c) {
        if (c.dataset.pcardReady) return;
        c.dataset.pcardReady = '1';
        initCard(c);
      });
      // Form stock-toggle
      document.querySelectorAll('[data-form-toggle-stock]').forEach(function (cb) {
        if (cb.dataset.stockReady) return;
        cb.dataset.stockReady = '1';
        var fields = cb.closest('form').querySelector('[data-form-stock-fields]');
        if (!fields) return;
        function sync() {
          if (cb.checked) { fields.classList.add('is-open'); fields.removeAttribute('hidden'); }
          else { fields.classList.remove('is-open'); fields.setAttribute('hidden', ''); }
        }
        cb.addEventListener('change', sync);
        sync();
      });

      // Series → Sizes cascade (per-series velikost dropdown)
      document.querySelectorAll('[data-form-stock-fields]').forEach(function (container) {
        if (container.dataset.sizeReady) return;
        container.dataset.sizeReady = '1';
        var raw = container.getAttribute('data-size-mapping') || '';
        var mapping = {};
        raw.split('\n').forEach(function (line) {
          var idx = line.indexOf(':');
          if (idx < 0) return;
          var key = line.slice(0, idx).trim().toUpperCase();
          var vals = line.slice(idx + 1).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          if (key && vals.length) mapping[key] = vals;
        });

        function wireRow(row) {
          if (row.dataset.sizeWired) return;
          row.dataset.sizeWired = '1';
          var serieSelect = row.querySelector('[data-field="serie"]');
          var sizeSelect = row.querySelector('[data-field="velikost"]');
          if (!serieSelect || !sizeSelect) return;

          // Cache the original "default" option list (placeholder + all sizes from global setting)
          if (!sizeSelect.dataset.defaultsCached) {
            sizeSelect.dataset.defaultsCached = '1';
            sizeSelect.dataset.defaultsHtml = sizeSelect.innerHTML;
          }
          var defaultsHtml = sizeSelect.dataset.defaultsHtml;
          var placeholderOption = sizeSelect.querySelector('option[value=""]');
          var placeholderText = placeholderOption ? placeholderOption.textContent : '— Vyberte velikost —';

          function refresh() {
            var key = (serieSelect.value || '').trim().toUpperCase();
            if (key && mapping[key]) {
              var html = '<option value="">' + placeholderText + '</option>';
              mapping[key].forEach(function (s) {
                html += '<option value="' + s.replace(/"/g, '&quot;') + '">' + s + '</option>';
              });
              sizeSelect.innerHTML = html;
            } else {
              sizeSelect.innerHTML = defaultsHtml;
            }
            sizeSelect.value = '';
          }
          serieSelect.addEventListener('change', refresh);
          // Don't run refresh() on init — keep defaults until user picks series
        }

        container.querySelectorAll('[data-stock-item]').forEach(wireRow);
        container.__wireRow = wireRow; // expose for clone handler
      });

      // Stock item rows — add / remove
      document.querySelectorAll('[data-add-stock-row]').forEach(function (btn) {
        if (btn.dataset.addReady) return;
        btn.dataset.addReady = '1';
        var container = btn.closest('[data-form-stock-fields]').querySelector('[data-stock-items]');

        function updateRemoveButtons() {
          var items = container.querySelectorAll('[data-stock-item]');
          items.forEach(function (it, idx) {
            var rm = it.querySelector('[data-remove-row]');
            if (rm) {
              if (items.length > 1) rm.removeAttribute('hidden');
              else rm.setAttribute('hidden', '');
            }
          });
        }
        function renumberRows() {
          var items = container.querySelectorAll('[data-stock-item]');
          items.forEach(function (it, idx) {
            var num = idx + 1;
            it.setAttribute('data-stock-index', num);
            var numSpan = it.querySelector('[data-stock-num]');
            if (numSpan) numSpan.textContent = num;
            it.querySelectorAll('[data-field]').forEach(function (el) {
              var field = el.getAttribute('data-field');
              el.name = 'contact[polozka_' + num + '_' + field + ']';
            });
          });
        }
        function attachRemove(item) {
          var rm = item.querySelector('[data-remove-row]');
          if (!rm || rm.dataset.removeReady) return;
          rm.dataset.removeReady = '1';
          rm.addEventListener('click', function () {
            item.remove();
            renumberRows();
            updateRemoveButtons();
          });
        }

        // Attach remove handler to existing first row
        container.querySelectorAll('[data-stock-item]').forEach(attachRemove);
        updateRemoveButtons();

        btn.addEventListener('click', function () {
          var items = container.querySelectorAll('[data-stock-item]');
          var template = items[0];
          var clone = template.cloneNode(true);
          // Reset values in clone
          clone.querySelectorAll('input, select').forEach(function (el) {
            if (el.tagName === 'SELECT') el.selectedIndex = 0;
            else el.value = '';
          });
          // Reset remove button readiness flag
          var rm = clone.querySelector('[data-remove-row]');
          if (rm) rm.removeAttribute('data-remove-ready');
          container.appendChild(clone);
          attachRemove(clone);
          renumberRows();
          updateRemoveButtons();
          // Wire size cascade on clone (reset cache flags first)
          clone.removeAttribute('data-size-wired');
          var sizeSel = clone.querySelector('[data-field="velikost"]');
          if (sizeSel) sizeSel.removeAttribute('data-defaults-cached');
          var stockContainer = btn.closest('[data-form-stock-fields]');
          if (stockContainer && stockContainer.__wireRow) stockContainer.__wireRow(clone);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
